
export {Provider,
__UNSTABLE_DataClient,
useProvider} from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$provider.js';
